export default __webpack_public_path__ + "static/media/join2.c2139548.jpeg";